import firebase from "firebase"

const firebaseConfig = {
    apiKey: 'AIzaSyCmQQzj2ISRZYSwCjH1y_Goh5MmHkBPzCc',
    authDomain: 'unterzeichner-3cdb0.firebaseapp.com',
    databaseURL: 'https://unterzeichner-3cdb0-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: "unterzeichner-3cdb0",
    storageBucket: 'unterzeichner-3cdb0.appspot.com'
  };
    firebase.initializeApp(firebaseConfig);

export default firebase;